export const BridgeVolumeChartData = [
    { x: 'Jan', y1: 50},
    { x: 'Feb', y1: 100},
    { x: 'Mar', y1: 200},
    { x: 'Apr', y1: 250},
    { x: 'May', y1: 300},
    { x: 'June', y1: 300},
    { x: 'July', y1: 600},
  ];